<script>
  let timeTaken = 0;
  function onClick() {
    let start = new Date().getTime();
    fetch("https://n-production-game-api.sekai-en.com/api/system", {
      mode: "no-cors",
      headers: {
        "Accept-Encoding": "deflate, gzip",
        "Content-Type": "application/octet-stream",
        "Accept": "application/octet-stream",
		"X-OperatingSystem": "Android OS 7.1.2 / API-25 (NRD90M/G955FXXU1AQJ5)",
        "X-Platform": "Android",
      },
    }).then(() => {
      let end = new Date().getTime();
      timeTaken = end - start;
    });
  }
</script>

<main>
  <h1>Ensekai Latency Test</h1>
  <p>This is a quick page to test your latency to the ENSekai server.</p>
  <button on:click={onClick}>Test</button>
  <p>Time taken : {timeTaken} ms</p>
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
